/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Sales_Order_Not_LockableInputs */

const en_error_sales_order_not_lockable = /** @type {(inputs: Error_Sales_Order_Not_LockableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This order cannot be locked now.`)
};

/**
* | output |
* | --- |
* | "This order cannot be locked now." |
*
* @param {Error_Sales_Order_Not_LockableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_sales_order_not_lockable = /** @type {((inputs?: Error_Sales_Order_Not_LockableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sales_Order_Not_LockableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_sales_order_not_lockable(inputs)
});